<template>
  <el-dialog
    :visible.sync="innerVisible"
    custom-class="exclusive-service-dialog"
    :show-close="false"
    :close-on-click-modal="true"
    :modal-append-to-body="false"
  >
    <div class="dialog-content">
      <el-tabs v-model="activeTab" @tab-click="onChangeTab">
        <el-tab-pane label="签证专家" name="cs">
          <transition name="left">
            <cs-exclusive-service-card v-if="activeTab === 'cs'" @close="innerVisible = false"  class="transition" :exclusive-data="peerCSData"></cs-exclusive-service-card>
          </transition>
        </el-tab-pane>
        <el-tab-pane label="商务经理" name="bd">
          <transition name="right">
            <bd-exclusive-service-card v-if="activeTab === 'bd'" @close="innerVisible = false"  class="transition" :exclusive-data="peerBdData"></bd-exclusive-service-card>
          </transition>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CsExclusiveServiceCard from './cs-exclusive-service-card.vue';
import BdExclusiveServiceCard from './bd-exclusive-service-card';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    CsExclusiveServiceCard,
    BdExclusiveServiceCard,
  },
  data() {
    return {
      activeTab: 'cs',
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
    ...mapState('user', [
      'peerCSData',
      'peerBdData',
    ]),
  },
  methods: {
    ...mapActions('user', ['getPeerCSData']),
    onChangeTab(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style lang="less">
.exclusive-service-dialog {
  &.el-dialog {
    width: 400px;
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
  }


  .el-tabs {
    .el-tabs__header {
      margin: 0;
    }
    .el-tabs__active-bar {
      height: 4px;
      background: #599FFF;
      border-radius: 1px;
      &::before, &::after {
        content: '';
        position: absolute;
        top: 0;
        background-color: #2F333D;
        width: 32%;
        height: 100%;
        display: inline-block;
      }
      &::before {
        left: 0;
      }
      &::after {
        right: 0;
      }
    }
    .el-tabs__nav {
      width: 100%;
      background: #2F333D;
      display: flex;
      .el-tabs__item {
        flex: 1;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 18px;
        color: #FFFFFF;
        &.is-active {
          color: #FFFFFF;
        }
      }
    }
  }

}
</style>

<style lang="less" scoped>
/* 定义淡入淡出过渡动画 */
.transition {
  transition: all .4s ease;
}

.right-enter,
.right-leave-to {
  opacity: 0;
  transform: translateX(100%);
}


.left-enter,
.left-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/dialog/exclusive-service-dialog/exclusive-service-dialog.vue